import api, { getAccessToken } from './axiosConfig';
import { requireAuthToken } from '../utils/authUtils';

const journalEntriesAPI = {
  getAll: async (params = {}) => {
    try {
      requireAuthToken(getAccessToken);
      const response = await api.get('/journal-entries', { params });
      return response.data;
    } catch (error) {
      throw error.response?.data?.message || 'Failed to fetch journal entries';
    }
  },

  getById: async (id) => {
    try {
      requireAuthToken(getAccessToken);
      const response = await api.get(`/journal-entries/${id}`);
      return response.data;
    } catch (error) {
      throw error.response?.data?.message || 'Failed to fetch journal entry';
    }
  },

  create: async (entryData) => {
    try {
      requireAuthToken(getAccessToken);
      const response = await api.post('/journal-entries', entryData);
      return response.data;
    } catch (error) {
      throw error.response?.data?.message || 'Failed to create journal entry';
    }
  },

  update: async (id, entryData) => {
    try {
      requireAuthToken(getAccessToken);
      const response = await api.put(`/journal-entries/${id}`, entryData);
      return response.data;
    } catch (error) {
      throw error.response?.data?.message || 'Failed to update journal entry';
    }
  },

  delete: async (id) => {
    try {
      requireAuthToken(getAccessToken);
      const response = await api.delete(`/journal-entries/${id}`);
      return response.data;
    } catch (error) {
      throw error.response?.data?.message || 'Failed to delete journal entry';
    }
  },

  // Journal entry specific methods
  post: async (id) => {
    try {
      requireAuthToken(getAccessToken);
      const response = await api.post(`/journal-entries/${id}/post`);
      return response.data;
    } catch (error) {
      throw error.response?.data?.message || 'Failed to post journal entry';
    }
  },

  duplicate: async (id) => {
    try {
      requireAuthToken(getAccessToken);
      const response = await api.post(`/journal-entries/${id}/duplicate`);
      return response.data;
    } catch (error) {
      throw error.response?.data?.message || 'Failed to duplicate journal entry';
    }
  },

  void: async (id, payload = {}) => {
    try {
      requireAuthToken(getAccessToken);
      const response = await api.post(`/journal-entries/${id}/void`, payload);
      return response.data;
    } catch (error) {
      throw error.response?.data?.message || "Failed to void journal entry";
    }
  },

  getByStatus: async (status) => {
    try {
      requireAuthToken(getAccessToken);
      const response = await api.get(`/journal-entries/status/${status}`);
      return response.data;
    } catch (error) {
      throw error.response?.data?.message || `Failed to fetch ${status} journal entries`;
    }
  },

  getByDateRange: async (startDate, endDate) => {
    try {
      requireAuthToken(getAccessToken);
      const response = await api.get('/journal-entries', {
        params: { startDate, endDate }
      });
      return response.data;
    } catch (error) {
      throw error.response?.data?.message || 'Failed to fetch journal entries by date range';
    }
  },

  getByAccount: async (accountId) => {
    try {
      requireAuthToken(getAccessToken);
      const response = await api.get(`/journal-entries/account/${accountId}`);
      return response.data;
    } catch (error) {
      throw error.response?.data?.message || 'Failed to fetch journal entries by account';
    }
  },
   // NEW: Client-specific journal entries
   getByClient: async (clientId, params = {}) => {
    try {
      const response = await api.get(`/journal-entries/client/${clientId}`, { params });
      return response.data;
    } catch (error) {
      throw error.response?.data?.message || 'Failed to fetch client journal entries';
    }
  },
  
  getAuditTrail: async (id) => {
    try {
      const response = await api.get(`/journal-entries/${id}/audit-trail`);
      return response.data;
    } catch (error) {
      throw error.response?.data?.message || "Failed to fetch audit trail";
    }
  },

  generateEntryNumber: async () => {
    try {
      const response = await api.get('/journal-entries/generate-entry-number');
      return response.data;
    } catch (error) {
      throw error.response?.data?.message || 'Failed to generate journal entry number';
    }
  },

  // journalEntriesAPI.js - Add this method
  postToGeneralLedger: (journalEntryId, generalLedgerEntries) => 
  api.post(`/journal-entries/${journalEntryId}/post-to-general-ledger`, { generalLedgerEntries }),

  getMemoSuggestions: async (queryString) => {
    try {
      const response = await api.get(`/journal-entries/memo-suggestions${queryString}`);
      return response.data;
    } catch (error) {
      throw error.response?.data?.message || 'Failed to fetch memo suggestions';
    }
  }

};

export default journalEntriesAPI;